function AccountCircle() {
  return (
    <div className="bg-blue10 w-11 h-11 rounded-full p-2">
      <img src="/assets/images/icon-avatar-line.svg" alt="Account" className="w-full h-full" />
    </div>
  );
}

export default AccountCircle;
